import React from "react";
import { styled } from "@mui/material/styles";

const FormMain = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    marginLeft: "3.9rem",
  },
}));

const FormMainLayouts = (props) => {
  return <FormMain>{props.children}</FormMain>;
};

export default FormMainLayouts;
